<span *ngIf="netPrice && quantity && unit">
  <span *ngIf="unitOfMeasurement == 'l'">Literpreis:</span>
  <span *ngIf="unitOfMeasurement == 'kg'">Kilopreis:</span>
  <span *ngIf="unitOfMeasurement == 'l' || unitOfMeasurement == 'kg'">
      {{this.articleService.getBasicPrice(quantity, unit, netPrice || 0, taxRate || 0, (customer$ | async)?.priceMode || 'gross')}}
  </span>
</span>
<span class="empty-basic-price" *ngIf="!netPrice || !quantity || !unit">

</span>

